(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-stickers"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SECTIONS = document.querySelectorAll('[data-sticker-section]');
  if (!SECTIONS.length) return;

  SECTIONS.forEach(function (ROOT) {
    var WRAP   = ROOT.querySelector('.dfs-sticker');
    var RING   = ROOT.querySelector('.dfs-sticker .sticker');
    var IMG    = ROOT.querySelector('.dfs-sticker .submark img');
    var BTN    = ROOT.querySelector('.dfs-sticker-trigger');
    var MODAL  = ROOT.querySelector('.dfs-modal');
    var PANEL  = MODAL ? MODAL.querySelector('.dfs-modal__panel') : null;
    var CLOSES = MODAL ? MODAL.querySelectorAll('[data-close]') : [];

    if (!WRAP || !RING || !IMG) return;

    if (!RING.hasAttribute('data-raw')) {
      RING.setAttribute('data-raw', (RING.textContent || '').trim());
    }

    function cssNumber(varName, fallback) {
      var v = getComputedStyle(WRAP).getPropertyValue(varName).trim();
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    function getCanvasFont(el) {
      var cs = getComputedStyle(el);
      return [
        cs.fontStyle,
        cs.fontVariant,
        cs.fontWeight,
        cs.fontSize,
        cs.fontFamily
      ].join(' ');
    }

    function build() {
      var text = RING.getAttribute('data-raw') || '';
      if (!text.length) return;

      var imgW = IMG.getBoundingClientRect().width;
      if (!imgW) { requestAnimationFrame(build); return; }

      var gapPx       = cssNumber('--ring-gap', 12);
      var baselinePad = cssNumber('--ring-offset', 2);
      var startDeg    = cssNumber('--ring-start-deg', -90);
      var direction   = cssNumber('--ring-direction', 1) >= 0 ? 1 : -1;

      var R = (imgW / 2) + gapPx + baselinePad;
      var D = Math.ceil(R * 2);

      WRAP.style.setProperty('--ring-diameter', D + 'px');
      RING.style.width  = D + 'px';
      RING.style.height = D + 'px';

      var chars = Array.from(text);
      var count = chars.length;
      if (!count) return;

      // Measure each character's real rendered width via canvas
      var canvas = document.createElement('canvas');
      var ctx    = canvas.getContext('2d');
      ctx.font   = getCanvasFont(RING);

      var widths = chars.map(function (ch) {
        // Spaces would measure as ~0 — give them a reasonable minimum
        var w = ctx.measureText(ch).width;
        return w < 2 ? ctx.measureText('n').width * 0.5 : w;
      });

      var totalTextWidth = widths.reduce(function (sum, w) { return sum + w; }, 0);

      // Full circumference at radius R
      var circumference = 2 * Math.PI * R;

      // Spread leftover space evenly as identical gaps between every character
      var totalGap    = circumference - totalTextWidth;
      var gapPerChar  = totalGap / count;

      var startRad = startDeg * Math.PI / 180;
      var arcAccum = 0;

      RING.innerHTML = '';

      for (var i = 0; i < count; i++) {
        // Each slot = character width + one even gap
        // Character is centered in its slot
        var slotWidth = widths[i] + gapPerChar;
        var midArc    = arcAccum + slotWidth / 2;
        var midRad    = startRad + direction * (midArc / R);
        var angleDeg  = midRad * 180 / Math.PI;

        var span = document.createElement('span');
        span.textContent = chars[i];

        // rotate to angle → push out to radius → orient tangent to circle → center glyph
        span.style.transform =
          'rotate('    + angleDeg        + 'deg) '  +
          'translate(' + R               + 'px) '   +
          'rotate('    + (90 * direction) + 'deg) ' +
          'translateX(-50%)';

        RING.appendChild(span);
        arcAccum += slotWidth;
      }
    }

    // ── Initial build ─────────────────────────────────────────────────────────
    if (IMG.complete) {
      build();
    } else {
      IMG.addEventListener('load', build, { once: true });
    }

    // ── Rebuild on resize (debounced) ─────────────────────────────────────────
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(build, 120);
    });

    // ── Rebuild when image resizes ────────────────────────────────────────────
    if ('ResizeObserver' in window) {
      new ResizeObserver(build).observe(IMG);
    }

    // ── External rebuild trigger ──────────────────────────────────────────────
    document.addEventListener('df:rebuild-sticker', function (e) {
      if (e && e.detail && e.detail.root && e.detail.root !== ROOT) return;
      build();
    });

    // ── Modal ─────────────────────────────────────────────────────────────────
    if (!MODAL) return;

    var lastFocused = null;

    function openModal() {
      lastFocused = document.activeElement;
      MODAL.classList.add('is-open');
      MODAL.setAttribute('aria-hidden', 'false');
      if (PANEL) PANEL.focus();
      document.addEventListener('keydown', onKeyDown);
      if (BTN) BTN.setAttribute('aria-expanded', 'true');
    }

    function closeModal() {
      MODAL.classList.remove('is-open');
      MODAL.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeyDown);
      if (BTN) {
        BTN.setAttribute('aria-expanded', 'false');
        BTN.focus();
      } else if (lastFocused) {
        lastFocused.focus();
      }
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') closeModal();
    }

    if (BTN && BTN.tagName === 'BUTTON') {
      BTN.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    }

    CLOSES.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
